import { marginBottom, marginTop, typography } from "../../../../common/styles";
import { List } from "../../../../common/components";
import React from "react";
import { Resource } from "../../../../AppDataProvider/types";
import ResourceList from "../ResourceList/ResourceList";
import sortResourcesByGroup from "../../sortResourcesByGroup/sortResourcesByGroup";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
export type ResourcesByGroupListProps = {
  resources: Resource[];
};
const GroupName = styled.h2`
  ${typography.title};
  color: ${({
  theme
}) => theme.colours.primaryText};
  ${marginTop.zero}
  ${marginBottom.l}
`;
const ListItem = styled.li`
  &:not(:first-child) {
    ${marginTop.l}
  }
`;
export function ResourcesByGroupList(props: ResourcesByGroupListProps) {
  const {
    resources
  } = props;
  const {
    t
  } = useTranslation();
  const groupedResources = sortResourcesByGroup(resources);
  return <List data-sentry-element="List" data-sentry-component="ResourcesByGroupList" data-sentry-source-file="ResourcesByGroupList.tsx">
      {groupedResources.map(group => <ListItem key={group.groupId}>
          <GroupName>{group.groupName ?? t("uncategorised")}</GroupName>
          <ResourceList resources={group.resources} isSubList />
        </ListItem>)}
    </List>;
}
export default ResourcesByGroupList;